/**
 * The retired Home console's hosts (home, home-dev, home-staging .veoride.com) now point at this
 * app only for the technician forms page (`/tech`, opened by the VeoTech apps' "Form Access").
 * Anything else there is an old bookmark: send it to the matching Manhattan host.
 */
const LEGACY_HOME = /^home(-dev|-staging)?\.veoride\.com$/;

/** The URL to redirect to, or null to render this app. */
export function legacyHomeTarget(loc: Pick<Location, 'hostname' | 'pathname' | 'search'>): string | null {
  const m = LEGACY_HOME.exec(loc.hostname);
  if (!m) return null;
  if (loc.pathname === '/tech' || loc.pathname.startsWith('/tech/')) return null;
  return `https://manhattan${m[1] ?? ''}.veoride.com${loc.pathname}${loc.search}`;
}
